import NewsletterNineteenContainer from "./containers/NewsletterNineteenContainer";
export default NewsletterNineteenContainer;
